var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "page-dialog",
      attrs: {
        visible: _vm.visible,
        width: "700px",
        "append-to-body": "",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": (val) => _vm.emitUpdateVisible(val),
        close: _vm.handleCancel,
        closed: _vm.handleClosed,
      },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function () {
            return [
              _c(
                "MemberUidHeader",
                {
                  attrs: {
                    username: _vm.targetInfo.username,
                    uid: _vm.uid,
                    "vip-level": _vm.targetInfo.vip_level,
                  },
                },
                [
                  _c("span", { staticClass: "dialog-subtitle" }, [
                    _vm._v("设置RTP"),
                  ]),
                ]
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "dialog-footer" },
                [
                  _c("el-button", { on: { click: _vm.handleCancel } }, [
                    _vm._v("取消"),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.submitting },
                      on: { click: _vm.handleConfirm },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "formRef",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "80px",
            size: "mini",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "RTP", prop: "rtp" } },
            [
              _c("el-input-number", {
                staticStyle: { width: "210px" },
                attrs: {
                  placeholder: "输入0-97之间的数字",
                  clearable: "",
                  min: 0,
                  max: 97,
                },
                model: {
                  value: _vm.form.rtp,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "rtp", $$v)
                  },
                  expression: "form.rtp",
                },
              }),
              _c("div", { staticClass: "rtp-range-hint" }, [
                _c("span", [_vm._v("RTP范围 0-97,0表示与大盘一致")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }